import {
  getRedirectResult,
  signInWithPopup,
  signInWithRedirect,
} from 'firebase/auth';
import { auth, googleProvider } from '../firebaseConfig';
import { requireConnectionForMutation } from './connectivityService';

const PENDING_INVITE_KEY = 'narafin.pendingInvite';

export const getInviteTokenFromLocation = () => (
  new URLSearchParams(window.location.search).get('invite') || ''
);

export const rememberPendingInvite = (token) => {
  if (token) sessionStorage.setItem(PENDING_INVITE_KEY, token);
};

export const getPendingInvite = () => (
  getInviteTokenFromLocation() || sessionStorage.getItem(PENDING_INVITE_KEY) || ''
);

export const clearPendingInvite = () => {
  sessionStorage.removeItem(PENDING_INVITE_KEY);
  const url = new URL(window.location.href);
  url.searchParams.delete('invite');
  window.history.replaceState({}, document.title, `${url.pathname}${url.search}${url.hash}`);
};

const shouldUseRedirect = () => {
  const standalone = window.matchMedia?.('(display-mode: standalone)').matches
    || window.navigator.standalone === true;
  const mobile = window.matchMedia?.('(max-width: 767px)').matches
    || /Android|iPhone|iPad|iPod/i.test(window.navigator.userAgent);
  const safari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  return standalone || mobile || safari;
};

export const completeGoogleRedirect = async () => {
  const result = await getRedirectResult(auth);
  return result?.user || null;
};

export const signInWithGoogle = async ({ inviteToken = '' } = {}) => {
  requireConnectionForMutation();
  rememberPendingInvite(inviteToken);

  if (shouldUseRedirect()) {
    await signInWithRedirect(auth, googleProvider);
    return { redirected: true, user: null };
  }

  try {
    const result = await signInWithPopup(auth, googleProvider);
    return { redirected: false, user: result.user };
  } catch (error) {
    if (error.code === 'auth/popup-blocked') {
      await signInWithRedirect(auth, googleProvider);
      return { redirected: true, user: null };
    }
    throw error;
  }
};
